"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDisclaimerText = exports.StyledDisclaimerKey = exports.StyledDisclaimerDataContainer = exports.StyledDisclaimerContainer = exports.StyledCloseButton = exports.StyledDisclaimerLayer = exports.StyledDisclaimerModal = exports.animationClassName = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.animationClassName = 'dislaimer-modal-animation';
exports.StyledDisclaimerModal = components_core_1.styled.div `
  position: fixed;
  width: 100%;
  bottom: 0px;
  left: 0px;
  right: 0px;
  pointer-events: none;
  @keyframes ${exports.animationClassName} {
    from {
      bottom: -50px;
    }
    to {
      bottom: 0px;
    }
  }
  .layer-animation {
    animation-fill-mode: both;
    animation-duration: 400ms;
    opacity: 1;
    animation-name: ${exports.animationClassName};
  }
`;
exports.StyledDisclaimerLayer = components_core_1.styled.div `
  display: flex;
  position: relative;
  max-height: 50vh;
  background-color: rgba(0, 0, 0, 0.75);
  pointer-events: all;
  padding: 16px 16px 0px;
  overflow-y: hidden;
  color: #ffffff;
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    margin: 0px auto;
    max-width: 80vw;
  }
`;
exports.StyledCloseButton = components_core_1.styled.div `
  position: absolute;
  right: 16px;
  top: 16px;
  button {
    padding-left: 20px;
    padding: 0px;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    color: rgb(255, 255, 255);
    pointer-events: all;
  }
`;
exports.StyledDisclaimerContainer = components_core_1.styled.div `
         padding-right: 30px;
         overflow-y: auto;
         /* Hide scrollbar for Chrome, Safari and Opera */
         &::-webkit-scrollbar {
           display: none;
         }
         /* Hide scrollbar for IE, Edge and Firefox */
         -ms-overflow-style: none; /* IE and Edge */
         scrollbar-width: none; /* Firefox */
       `;
exports.StyledDisclaimerDataContainer = components_core_1.styled.div `
  display: flex;
  padding-bottom: 10px;
`;
exports.StyledDisclaimerKey = components_core_1.styled.div `
  flex: 0 0 28px;
`;
exports.StyledDisclaimerText = components_core_1.styled.div ``;
